/**
 * Created by DELL on 2017/7/20.
 */
import * as types from '../constants/ActionTypes'
import api from '../../utils/api'

let reportPageOrForm = (isShow) =>{
    return{
        type: types.REPORT_PAGE_FORM,
        payload:{isShow}
    }
}

let formOrVideoOrPhoto = (isShow) =>{
    return{
        type: types.FORM_VIDEO_PHOTO,
        payload:{isShow}
    }
}

let selectedCar = (isShow) => {
    return{
        type: types.SELECTED_CAR,
        payload:{isShow}
    }
}

let showPictureModal = (isShow) => {
    return{
        type:types.SHOWPICTUREMODAL,
        payload:{isShow}
    }
}
export default {
    reportPageOrForm,
    formOrVideoOrPhoto,
    selectedCar

}